module.exports = __webpack_public_path__ + "static/img/2.ec51bfc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/sp/2.png
// module id = iKiC
// module chunks = 0